<!-- PROJECTS -->
<template>
    <v-row no-gutters class="fill-height">
        <!-- // * LEFT PANEL -->
        <v-col :cols="GET_panelLayout.leftPanel">
            <v-row class="px-2 mt-2 pa-0" dense>
                <!-- // * DESCRIPTION -->
                <v-col :cols="computedCols">
                    <v-row no-gutters class="">
                        <v-col class="px-2" cols="12" xs="6" sm="6" md="12">
                            <app-text category="content-title">{{ $t(`${langPath}.title`) }}<v-icon class="ml-2" @click="MIX_help(GET_help)">icons8-help</v-icon></app-text>
                            <app-text class="help-text" v-if="GET_help && GET_currentUser.userType === 'CONTRACTOR'" v-html="$t(`${langPath}.text.contractor`)"></app-text>
                            <app-text class="help-text" v-if="GET_help && GET_currentUser.userType !== 'CONTRACTOR'" v-html="$t(`${langPath}.text.default`)"></app-text>
                        
                        </v-col>
                    </v-row>
                </v-col>
                <!-- // * FILTERS -->
                <v-col :cols="computedCols" class="px-2">
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="12" md="6" class="">
                            <v-text-field background-color="white" prepend-inner-icon="icons8-search" filled dense :label="$t('filters.search')" v-model="search" clearable hide-details></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" filled dense clearable :label="$t('filters.workType')" hide-details></v-select>
                        </v-col> -->
                        <v-col cols="12" xs="12" sm="12" md="6" class="d-flex align-center" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-select :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="sortBy" :items="filteredHeaders" item-text="text" item-value="value" filled clearable dense :label="$t(`filters.sortBy`)" hide-details>
                                <template v-slot:item="data">{{ $t(`fields.${data.item.text}`) }}</template>
                                <template v-slot:selection="data">{{ $t(`fields.${data.item.text}`) }}</template>
                            </v-select>
                            <v-btn icon class="ml-2" @click="filter.sortAsc = !filter.sortAsc"><v-icon :class="{ 'icons8-down-arrow': filter.sortAsc, 'icons8-up-arrow': !filter.sortAsc }" class="text-h5"></v-icon></v-btn>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-autocomplete :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.site" filled dense :label="$t('filters.site')" hide-details auto-select-first clearable :items="sites" item-text="siteName" return-object></v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-autocomplete :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.projectManager" filled dense :label="$t('filters.projectManager')" hide-details auto-select-first clearable :items="usersHosts" item-text="userName" return-object></v-autocomplete>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" class="" v-if="$vuetify.breakpoint.lgAndUp && ['SM','SA','DA'].includes(GET_currentUser.userLevel)">
                            <v-autocomplete :menu-props="{ top: false, offsetY: true }" :attach="true" background-color="white" v-model="filter.organisation" filled dense :label="$t('filters.organisation')" hide-details auto-select-first clearable :items="organisations" item-text="organisationName" return-object>
                                <template v-slot:item="data">
                                    {{ data.item.organisationName }}
                                    <span v-if="data.item.organisationStatus === 'PENDING'" class="warning--text font-weight-bold pl-1">(PENDING)</span>
                                    <span class="pl-1 font-weight-thin grey--text text--darken-1 caption">{{ data.item.organisationType }}</span>
                                </template>
                                <template v-slot:selection="data">
                                    {{ data.item.organisationName }}
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- // * Filter and Button Row -->
                <v-col cols="12" xs="12" sm="6" class="mt-2 d-flex align-center">
                    <div class="toogle-buttons pl-1">
                        <v-btn-toggle multiple color="white" active-class="white" background-color="lightgrey" dense v-model="filter.projectStatus">
                            <v-btn value="LIVE"><v-icon class="success--text icons8-checkmark-yes"></v-icon><span class="success--text caption">{{$t('filters.live')}}</span></v-btn>
                            <v-btn value="ONHOLD"><v-icon class="warning--text icons8-private"></v-icon><span class="warning--text caption">{{$t('filters.onhold')}}</span></v-btn>
                            <v-btn value="PENDING"><v-icon class="grey--text icons8-circle"></v-icon><span class="grey--text caption">{{$t('filters.pending')}}</span></v-btn>
                            <v-btn value="DRAFT" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)"><v-icon class="grey--text icons8-inactive-state"></v-icon><span class="grey--text caption">{{$t('filters.draft')}}</span></v-btn>
                        </v-btn-toggle>
                    </div>
                    <!-- // * SHOW DELETED -->
                    <div class="d-flex" v-if="$vuetify.breakpoint.mdAndUp && ['DA'].includes(GET_currentUser.userLevel)">
                        <v-icon class="ml-4 purple--text text-h4">icons8-trash</v-icon>
                        <v-switch @change="getTableData()" v-model="showDeleted" class="ml-1 purple--text" inset color="purple"></v-switch>
                    </div>
                </v-col>

                <v-col cols="12" xs="12" sm="6" class="mt-2 pl-4 pr-1 d-flex align-center">
                    <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
                    <!-- // * BUTTONS -->
                    <div v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)"><appbutton :label="$t(`buttons.add`)" icon="icons8-project" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" @click.native="openItem('', 'New', false)" /></div>
                    <div v-if="['VM','VA','CM','CA','SM','SA','DA'].includes(GET_currentUser.userLevel)" class="d-flex align-center">
                        <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.columns`)" icon="icons8-select-column" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="columnsDialog = true" /></div>
                        <!-- <div v-if="$vuetify.breakpoint.mdAndUp"><appbutton :label="$t(`buttons.export`)" icon="icons8-export-csv" type="secondary" iconclass="white--text" labelclass="white--text" showlabel="2xlOnly" @click.native="mix_exportDocuments" /></div> -->
                    </div>
                </v-col>

                <!-- // * TABLE -->
                <v-col class="px-2 tabledata" v-if="$vuetify.breakpoint.mdAndUp" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-data-table
                        :headers="filteredHeaders"
                        :items-per-page="MIX_itemsPerPage(MIX_breakpoint())"
                        :items="computedTableData"
                        item-key="id"
                        class="elevation-0"
                        hide-default-header
                        :search="search">
                        <!-- // HEADERS -->
                        <template v-slot:header="{ props }">
                            <th :align="head.align" class="pa-4 font-weight-medium" style="font-size:12px !important;" v-for="(head, index) in props.headers" :key="index">
                                {{ $t(`fields.${head.text}`) }}
                            </th>
                        </template>

                        <!-- // NAME -->
                        <template v-slot:[`item.projectName`]="{ item }">
                            <span v-if="item.delete !== null && item.delete !== '' && item.delete !== undefined" class="purple--text d-inline-block text-truncate" style="max-width: 200px;"><v-icon class="purple--text">icons8-trash</v-icon> {{ item.projectName}}</span>
                            <span v-else>{{ item.projectName }}</span>
                        </template>


                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="openItem(item.id, 'View', false)" depressed class="black--text white">Open<v-icon>mdi-chevron-right</v-icon></v-btn>
                        </template>
                        <template v-slot:[`item.projectStatus`]="{ item }">
                            <v-icon v-if="item.projectStatus === 'LIVE'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                            <v-icon v-if="item.projectStatus === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text icons8-private"></v-icon>
                            <v-icon v-if="item.projectStatus === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text icons8-circle"></v-icon>
                            <v-icon v-if="item.projectStatus === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>
                        </template>

                        <!-- // PROJECT MANAGER USER -->
                        <template v-slot:[`item.projectManager`]="{ item }">
                            <div @click="MIX_popupUser(item.projectManager.userId)" class="pointer noselect">
                                <v-icon v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">icons8-identification-documents</v-icon>
                                {{ item.projectManager.userName }}
                            </div>
                        </template>

                        <!-- // SITE -->
                        <template v-slot:[`item.site`]="{ item }">
                            <div v-if="item.site.length > 0" class="pointer noselect">
                                {{ item.site[0].siteName }}
                            </div>
                            <div v-else class="pointer noselect">
                                {{ item.site.siteName }}
                            </div>
                        </template>
                        <template v-slot:[`item.organisationName`]="{ item }">
                            <div v-if="item.organisationName.length > 0" class="pointer noselect">
                                {{ item.organisationName[0].organisationName }}
                            </div>
                            <div v-else class="pointer noselect">
                                {{ item.organisationName.organisationName }}
                            </div>
                        </template>
                        <!-- // SITE MANAGER USER -->
                        <template v-slot:[`item.siteManager`]="{ item }">
                            <div class="pointer noselect" v-if="item.siteManager !== ''">
                                <v-icon @click="MIX_popupUser(item.siteManager.userId)" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">icons8-identification-documents</v-icon>
                                {{ item.siteManager.userName }}
                            </div>
                        </template>

                        <!-- // CONTRACTOR -->
                        <!-- <template v-slot:[`item.organisationName`]="{ item }">
                            <div class="pointer noselect">
                                {{ item.organisationName }}
                            </div>
                        </template> -->
                        <!-- // CONTRACTOR MANAGER USER -->
                        <!-- <template v-slot:[`item.organisationManager`]="{ item }">
                            <div class="pointer noselect" v-if="item.siteManager !== ''">
                                <v-icon @click="MIX_popupUser(item.organisationManager.userId)" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">icons8-identification-documents</v-icon>
                                {{ item.organisationManager.userName }}
                            </div>
                        </template> -->

                        <!-- // CREATED USER DATA -->
                        <template v-slot:[`item.createdUserData`]="{ item }">
                            <div class="pointer noselect">
                                <v-icon @click="MIX_popupUser(item.createdUserData.userId)" v-if="['SM','SA','DA'].includes(GET_currentUser.userLevel)">icons8-identification-documents</v-icon>
                                {{ item.createdUserData.userName }}
                            </div>
                        </template>
                        <!-- // MODIFIED USER DATA -->
                        <template v-slot:[`item.modifiedUserData`]="{ item }">
                            <div @click="MIX_popupUser(item.modifiedUserData.userId)" class="pointer noselect">
                                <v-icon @click="MIX_popupUser(item.modifiedUserData.userId)">icons8-identification-documents</v-icon>
                                {{ item.modifiedUserData.userName }}
                            </div>
                        </template>
                        <!-- // DELETE USER DATA -->
                        <template v-slot:[`item.deleteUserData`]="{ item }">
                            <div v-if="item.deleteUserData !== undefined" @click="MIX_popupUser(item.deleteUserData.userId)" class="pointer noselect">
                                <v-icon>icons8-identification-documents</v-icon>
                                {{ item.deleteUserData.userName }}
                            </div>
                        </template>
                    </v-data-table>
                </v-col>
                <!-- // * MOBILE CARDS / Instead of Table -->
                <v-col class="px-2 pb-8 tabledata" v-if="$vuetify.breakpoint.smAndDown" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-row no-gutters>
                        <v-col cols="12" xs="12" class="my-1 pa-1 white tablecard" v-for="item in computedTableData" :key="item.id" @click="openItem(item.id, 'View', false)">
                            <v-row class="d-flex align-center justify-center pa-3 fill-height" no-gutters >
                                <v-col cols="2" class="">
                                    <!-- // TODO MEED TO MAKE THIS GENERIC -->
                                    <v-icon v-if="item[`${collectionItem}Status`] === 'LIVE'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 success--text icons8-checkmark-yes"></v-icon>
                                    <v-icon v-if="item[`${collectionItem}Status`] === 'ONHOLD'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 warning--text text--lighten-1 icons8-private"></v-icon>
                                    <v-icon v-if="item[`${collectionItem}Status`] === 'PENDING'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-circle"></v-icon>
                                    <v-icon v-if="item[`${collectionItem}Status`] === 'DRAFT'" :style="{'background-image': 'url(' + require('@/assets/circle.svg') + ')'}" class="iconbackground display-1 grey--text text--lighten-1 icons8-inactive-state"></v-icon>

                                </v-col>
                                <v-col cols="7" class="d-flex flex-column">
                                    <div style="margin: 0px !important; line-height: 20px !important;" class="noselect"><span class="d-inline-block text-truncate" style="max-width: 200px;">{{ item.projectName }}</span></div>
                                    <div style="" class="font-weight-bold caption grey--text text--darken-1 noselect">{{ item.projectManager.userName }}</div>
                                    <div class="caption noselect">{{ MIX_fromNow(item.createdDateTime, 'DD-MMM-YY HH:mm', true) }}</div>
                                </v-col>
                                <v-col cols="3" class="text-right pr-2"><v-icon @click="openItem(item.id, 'View', false)" depressed class="black--text white">mdi-chevron-right</v-icon></v-col>
                            </v-row>
                         </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
        <!-- // * RIGHT PANEL -->
        <!-- // * DYNAMIC COMPONENT PANEL -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn animate__faster"
            leave-active-class="animate__animated animate__fadeOut animate__faster"
            mode="out-in">
            <rightpanel></rightpanel>
        </transition>
        <!-- // * DYNAMIC COMPONENT DIALOG -->
        <v-dialog v-model="columnsDialog" scrollable max-width="300px">
            <v-card>
                <v-card-title>{{$t('miscHeadings.showHideColumns')}}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;">
                    <v-list>
                        <v-list-item v-for="(header, index) in columnHeaders" :key="index">
                          <v-list-item-title><v-checkbox color="grey darken-1" hide-details v-model="headers[index].hidden" :false-value="true" :true-value="false" :label="$t(`fields.${header.text}`)"></v-checkbox></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="text-right">
                    <v-spacer />
                    <v-btn color="primary" text @click="columnsDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- // * COPYRIGHT -->
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="px-0 mt-5 copyright">
            <appcopyright  />
        </v-col>
    </v-row>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'; // Map Actions / Getters
    export default {
        // * DATA
        data: () => ({
            collection: 'projects',
            collectionTitle: 'Projects',
            collectionItem: 'project',
            collectionItemTitle: 'Project',
            langPath: 'projects',
            columnsDialog: false,
            search: '', // Table Search
            sortBy: 'projectStartDate', // Default Table Sort By
            customWhere: [],
            filter: {
                // Default Filters
                sortAsc: false,
                projectStatus: ['LIVE', 'ONHOLD', 'PENDING', 'DRAFT'],
                organisation: '',
                projectManager: '',
                site: '',
            },
            // TABLE DATA
            tableData: [],
            // TABLE HEADERS
            headers: [
                // hidden shows the initial value of the column - hidden or visible
                // hides determines if you want to hide the column on screen resize
                { text: 'status', value: 'projectStatus', sortable: false, align: 'center', hidden: false, hide: false },
                { text: 'id', value: 'id', sortable: false, align: 'left', hidden: true, hide: false },
                { text: 'name', value: 'projectName', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'projectManager', value: 'projectManager', align: 'start', sortable: false, hidden: false, hide: true },
                { text: 'site', value: 'site', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'siteManager', value: 'siteManager', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'organisationId', value: 'organisationId', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'organisationName', value: 'organisationName', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'organisationType', value: 'organisationType', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'omUserId', value: 'omUserId', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'omUserName', value: 'omUserName', align: 'start', sortable: false, hidden: true, hide: true },
                { text: 'omUserJobTitle', value: 'omUserJobTitle', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'projectStartDate', value: 'projectStartDate', align: 'start', sortable: false, hidden: false, hide: false },
                { text: 'projectEndDate', value: 'projectEndDate', align: 'start', sortable: false, hidden: true, hide: false },
                { text: 'created', value: 'createdDateTime', sortable: false, align: 'start', hidden: true, hide: false },
                { text: 'createdUserData', value: 'createdUserData', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'modified', value: 'modifiedDateTime', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'modifiedUserData', value: 'modifiedUserData', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'delete', value: 'delete', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'deleteUserData', value: 'deleteUserData', align: 'left', sortable: false, hidden: true, hide: false },
                { text: 'actions', value: 'actions', align: 'right', sortable: false, sortable: false, hidden: false,  hide: false },
            ],
            // TODO ITEMS MARKED FOR REMOVAL
            //overviewProp: [],
            // columns: [],
            // projectHelp: projectHelpList,
            organisations: [], // ORGANISATIONS
            // DELETED
            showDeleted: false,
            ownerManagers: [],
            sites: [],
            usersHosts: [],
            filteredHeaders: []

        }),
        // * COMPUTED
        computed: {
            // Map Getters
            ...mapGetters({
                GET_currentUser: 'GET_currentUser',
                GET_panelLayout: 'GET_panelLayout',
                GET_organisations: 'GET_organisations',
                GET_help: 'GET_help',
                GET_sites: 'GET_sites',
                GET_usersHosts: 'GET_usersHosts'
            }),
            // Remove actions from Selectable Column Headers
            columnHeaders() {
                var t = this;
                var headers = t.headers;
                return (headers.filter((header) => {
                    return header.value !== 'actions'
                }));
            },            
            // Computed Table Headers
            // computedHeaders() {
            //     var t = this;
            //     var headers = t.headers;
            //     return (t.$filter(headers, {
            //         hidden: false, // filter headers based on initial hidden value
            //     }));
            // },
            // Computed Cols
            computedCols() {
                var t = this;
                var cols
                var leftPanel = t.GET_panelLayout.leftPanel
                switch (true) {
                    case (leftPanel === 12): cols = 6; break
                    case (leftPanel === 6): cols = 12; break;
                    default: cols = 12;
                }
                if (t.$vuetify.breakpoint.smAndDown) { cols = 12 }
                return cols
            },
            // Computed Table Data
            computedTableData() {
                var t = this;
                var tableData = t.tableData;
                // console.log(JSON.stringify(tableData, null, 2))
                // Filter by status
                tableData = tableData.filter(function(item) {
                    return t.filter.projectStatus.includes(item[t.collectionItem+'Status']);
                });
                // Filter by type
                if ((t.filter.type !== '') && (t.filter.type !== undefined) && (t.filter.type !== null)) {
                    tableData = tableData.filter(function(item) {
                        return t.filter.type === item[t.collectionItem + 'Type'];
                    });
                }

                // Filter by Manager
                if ((t.filter.projectManager !== '') && (t.filter.projectManager !== undefined) && (t.filter.projectManager !== null)) {
                    tableData = tableData.filter(function(item) {
                        return t.filter.projectManager.userId === item.projectManager.userId;
                    });
                }
                // Filter by Site
                if ((t.filter.site !== '') && (t.filter.site !== undefined) && (t.filter.site !== null)) {
                    tableData = tableData.filter(function(item) {
                        return t.filter.site.siteId === item.site.siteId;
                    });
                }
                // Filter by Contactor (CUSTOM)
                if ((t.filter.organisation !== '') && (t.filter.organisation !== undefined) && (t.filter.organisation !== null)) {
                    tableData = tableData.filter(function(item) {
                        if (item.organisation.length > 0) {
                            return t.filter.organisation.organisationId === item.organisation[0].organisationId;
                        } else {
                            return t.filter.organisation.organisationId === item.organisation.organisationId;
                        }
                    });
                }
                if (t.GET_currentUser.userType === 'CONTRACTOR') {
                    tableData = tableData.filter(function(item) {
                        if (item.organisation.length > 0) {
                            return t.GET_currentUser.organisation.organisationId === item.organisation[0].organisationId;
                        } else {
                            return t.GET_currentUser.organisation.organisationId === item.organisation.organisationId;
                        }
                    });
                }
                // Filter by Search Mobile
                if (t.search !== '' && t.$vuetify.breakpoint.smAndDown) {
                    tableData = tableData.filter(function(item) {
                        var itemName = item[t.collectionItem+'Name'].toUpperCase();
                        var search = t.search.toUpperCase();
                        return itemName.includes(search)
                    });
                }
                // Map the Fields to the Data Required, and Format Necessary Fields
                var tableDataList = tableData.map(e => {
                    return {
                        id: e.id,
                        projectStatus: e.projectStatus,
                        projectName: e.projectName,
                        projectManager: e.projectManager,
                        site: e.site,
                        siteManager: e.siteManager,
                        organisationId: e.organisation.organisationId,
                        organisationName: e.organisation,
                        organisationType: e.organisation.organisationType,
                        omUserId: e.organisationManager.id,
                        omUserName: e.organisationManager.userName,
                        omUserJobTitle: e.organisationManager.userJobTitle,
                        projectStartDate: t.MIX_formatDateTime(e.projectStartDate, 'x', 'DD-MMM-YY'),
                        projectEndDate: t.MIX_formatDateTime(e.projectEndDate, 'x', 'DD-MMM-YY'),
                        createdDateTime: t.MIX_formatDateTime(e.createdDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        createdUserData: e.createdUserData,
                        modifiedDateTime: t.MIX_formatDateTime(e.modifiedDateTime, 'x', 'DD-MMM-YY HH:mm'),
                        modifiedUserData: e.modifiedUserData,
                        delete: t.MIX_formatDateTime(e.delete, 'x', 'DD-MMM-YY HH:mm'),
                        deleteUserData: e.deleteUserData,
                    };
                });

                tableDataList = tableDataList.sort(function(a, b) {
                    return new Date(a.projectStartDate) - new Date(b.projectStartDate)
                })
                // Sort the Table by the Field in the Sort By Filter
                console.log("sortby = " + JSON.stringify(t.sortBy, null, 2))
                if (t.sortBy !== 'projectStartDate') {
                    tableDataList = t.$sortBy(tableDataList, t.sortBy)
                }
                if (!t.filter.sortAsc) {tableDataList.reverse()}
                // Sort the Table by the Field in the Sort By Filter
                // var sortResults = t.$sortBy(tableDataList, t.sortBy)
                // if (!t.filter.sortAsc) {sortResults.reverse()}
                return (tableDataList);
            },
        },
        watch: {
            GET_currentUser: {
                handler() {
                    this.getTableData();
                }, deep: true
            },
            GET_panelLayout: {
                handler() {
                    let t = this;
                    if (t.GET_panelLayout.rightPanel === 6) {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hide === false && header.hidden === false);
                        });
                    } else {
                        t.filteredHeaders = t.headers.filter((header) => {
                            return (header.hidden === false);
                        }) 
                    }
                }, deep: true,
            },
            headers: {
                handler() {
                    let t = this;
                     t.filteredHeaders = t.headers.filter((header) => {
                         return (header.hidden === false)
                     });
                }, deep: true,
            }            
        },
        // * METHODS
        methods: {
            ...mapActions({'ACT_openItem': 'ACT_openProject'}),
            // UPDATE BREADCRUMBS
            updateBreadcrumbs() {
                var t = this;
                var breadcrumbs = [];
                breadcrumbs.push ({ name: `${t.collectionTitle}`, path: `/${t.collection}`}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            // OPEN ITEM
            openItem: async function(id, process, popup) {
                var t = this;
                var item = {}
                t.dynamicComponentKey++;
                item.process = process;
                item.popup = popup;
                if (item.process !== 'New') {
                    var itemResult = await t.MIX_readDocumentById(t.collection, id)
                    item.data = itemResult.data;
                } else {
                    item.data = null;
                }
                t.ACT_openItem(item); // Open Item
                if (t.$vuetify.breakpoint.lgAndDown) {
                    t.MIX_fsDialog(true, t.collectionItemTitle, t.collectionItem);
                    t.MIX_setPanelLayout(12, 0, false, '');
                } else {
                    t.MIX_setPanelLayout(6, 6, true, t.collectionItemTitle, t.collectionItem);
                    // // * HIDE HEADERS
                    // for (var i = 0; i < t.headers.length; i++) {
                    //     if (t.headers[i].hide === true) {
                    //         t.headers[i].hidden = true;
                    //     }
                    // }
                }
                return;
            },
            // GET NOTICES SNAPSHOT METHOD
            getTableData: async function () {
                var t = this;
                var collection = t.$firebase.db.collection(t.collection)
                if (JSON.stringify(t.customWhere) !== '[]') {
                    for (var i = 0; i < t.customWhere.length; i++) {
                        var query = { field: t.customWhere[i].key, operator: t.customWhere[i].operator, value: t.customWhere[i].value }
                        collection = collection.where(query.field, query.operator, query.value)
                    }
                }
                // console.log('t.customWhere = ' + JSON.stringify(t.customWhere, null, 2))
                collection.onSnapshot(function(querySnapshot) {
                    t.tableData = [];
                    querySnapshot.forEach(function(doc) {
                        var document = doc.data()
                        document.id = doc.id;
                        if (!document.hasOwnProperty('delete')) {
                            t.tableData.push(document);
                        } else if (t.showDeleted) {
                            t.tableData.push(document);
                        } else {
                            // Do not Show Concern
                        }
                    });
                });
                return;
            },
        },
        // * MOUNTED
        async mounted() {
            // * DEFAULT MOUNTED
            var t = this;
            t.MIX_setPanelLayout(12, 0, false, ''); // Hide Right Panel
            t.updateBreadcrumbs(); // Update Breadcrumbs in Title
            // IF LOGGED IN AS CONTRACTOR THEN RESTRICT CONTENT BASED ON ORGANISATION
            // if (t.GET_currentUser.userType === 'CONTRACTOR') {
            //     t.customWhere.push ({ key: 'organisation.organisationId', operator: '==', value: t.GET_currentUser.organisation.organisationId });
            // }
            // t.customWhere.push ({ key: '', operator: '==', value: '' });
            t.getTableData(); // Get Table Data

            await t.MIX_usersHosts(); // Users who are STAFF and MANAGER / ADMIN
			t.usersHosts = t.GET_usersHosts;

            await t.MIX_usersMA();
            t.ownerManagers = t.GET_usersMA;

            await t.MIX_sites(); // UPDATE SITES LIST IN STORE
            t.sites = t.GET_sites; // STORE SITES IN LOCAL ARRAY

            await t.MIX_organisations();
            t.organisations = t.GET_organisations;


            await t.MIX_usersMA(); // UPDATE usersMA (Management and Admin)
            // * USERS Managers and Admin
            var usersMA = await this.GET_usersMA;
  //          await t.MIX_organisations(); // UPDATE organisations
//            var organisations = this.GET_organisations;
            // var organisations = t.organisations.filter(x => x.organisationType === 'CONTRACTOR'); // FILTER CONTRACTOR FROM ORGANISATIONS
            // this.organisations = organisations;

        },
    };
</script>

<style>
    .border-bottom-red { background-color: white; border-bottom: 2px solid var(--v-primary-base) !important; }
    .bottom { position: fixed; bottom: 30px; }
    @media only screen and (max-width: 600px) {
        .toogle-buttons {
            overflow: scroll;
        }
    }
</style>
